var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 18,
    fill: "none",
    viewBox: "0 0 12 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2355fc",
    d: "M11.166 3.082C10.107 1.197 8.226.045 6.134.002a7.991 7.991 0 00-.268-.001C3.774.044 1.893 1.196.833 3.081a6.442 6.442 0 00-.079 6.193l4.328 8.17.006.01a1.035 1.035 0 001.824.001l.006-.01 4.328-8.17a6.44 6.44 0 00-.08-6.193zM6 8.156c-1.353 0-2.454-1.135-2.454-2.531 0-1.396 1.1-2.531 2.454-2.531 1.353 0 2.454 1.135 2.454 2.531 0 1.396-1.1 2.531-2.454 2.531z"
  })));
}

export default SvgLocationBlue;